import { Heart } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const K1FianceVisa = () => {
  const faqs = [
    {
      question: "How long does the K-1 process take?",
      answer: "Total processing time typically ranges from 8-14 months from petition filing to visa issuance. USCIS processing takes 6-10 months, followed by NVC and consular processing taking 2-4 months. Premium processing is not available for K-1 visas.",
    },
    {
      question: "What happens after we get married?",
      answer: "After marriage, your spouse must file for adjustment of status (Form I-485) to get a green card. They'll receive a 2-year conditional green card initially. After 2 years, you'll jointly petition to remove conditions and obtain a 10-year green card.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Marry and Unite in the U.S.</h2>
        <p className="text-xl text-muted-foreground mb-8">
          The K-1 visa allows U.S. citizens to bring their foreign fiancé(e) to the United States for marriage. After marriage, your spouse can apply for adjustment of status to become a lawful permanent resident.
        </p>

        <h3 className="text-2xl font-bold mb-4">K-1 Visa Process</h3>
        <ol className="list-decimal pl-6 mb-6">
          <li>Filing Form I-129F petition with USCIS</li>
          <li>National Visa Center (NVC) processing</li>
          <li>Consular interview at U.S. embassy/consulate abroad</li>
          <li>Visa issuance and entry to U.S.</li>
          <li>Marriage within 90 days of entry</li>
          <li>Adjustment of status application (Form I-485)</li>
        </ol>

        <h3 className="text-2xl font-bold mb-4">Requirements</h3>
        <ul className="list-disc pl-6 mb-8">
          <li>You must be a U.S. citizen</li>
          <li>Have met your fiancé(e) in person within the past 2 years</li>
          <li>Both be legally free to marry</li>
          <li>Have a bona fide relationship</li>
        </ul>
        <p className="mb-8">
          We help gather evidence of your relationship and guide you through each step.
        </p>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="K-1 Fiancé(e) Visa"
      subtitle="Bring your fiancé(e) to the U.S. for marriage and adjustment of status"
      icon={<Heart className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default K1FianceVisa;
